export default __webpack_public_path__ + "static/media/loss-analysis-step-6-finance.a71e328f.gif";